<template>
	<div>
		<div
			class="header"
			:style="{backgroundImage: 'url(' + appweb.header + ')', backgroundSize:'cover'}"
		></div>
		<div class="menu-wrap themes_menu_wrap_1">
			<div class="container menu">
				<ul class="row nav nav-pills">
					<li class="themes_menu_main_li_1" @click="gotopath(`/${gameId}`, '首页')">首页</li>
					<li class="themes_menu_main_li_1 dropdown">
						<a
							class="dropdown-toggle menu_name"
							
							href="#"
							aria-haspopup="true"
							aria-expanded="false"
						>
							新闻动态
							<span class="caret"></span>
						</a>
						<ul class="dropdown-menu submenu themes_menu_sub_1">
							<li @click="gotopath(`/${gameId}/list/赛事新闻`, '赛事新闻')" class="themes_menu_sub_li_1">赛事新闻</li>
							<li @click="gotopath(`/${gameId}/list/赛事公告`, '赛事公告')" class="themes_menu_sub_li_1">赛事公告</li>
							<li @click="gotopath(`/${gameId}/pics/精彩图集`, '精彩图集')" class="themes_menu_sub_li_1">精彩图集</li>
						</ul>
					</li>
					<template v-for="menuitem in appweb.menus" :index="menuitem.key">
						<li
							v-if="menuitem.subs && menuitem.subs.length > 0"
							class="themes_menu_main_li_1 dropdown"
							:key="menuitem.id"
							:index="menuitem.id"
						>
							<a
								class="dropdown-toggle menu_name"
								href="javascript:;"
								aria-haspopup="true"
								aria-expanded="false"
							>
								{{menuitem.name}}
								<span class="caret"></span>
							</a>
							<ul class="dropdown-menu submenu themes_menu_sub_1">
								<template v-for="smenuitem in menuitem.subs">
									<li
										@click="gotopath(`/${gameId}/content/${smenuitem.id}`, smenuitem.name)"
										class="themes_menu_sub_li_1"
										:key="smenuitem.id"
									>{{smenuitem.name}}</li>
								</template>
							</ul>
						</li>
						<template v-else>
							<li
								@click="gotopath(`/${gameId}/content/${menuitem.id}`, menuitem.name)"
								:key="menuitem.id"
								class="themes_menu_main_li_1"
							>{{menuitem.name}}</li>
						</template>
					</template>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
	data() {
		return {};
	},

	mounted() {},
	methods: {
		gotopath(path, menuname) {
			this.$router.push({ path });
			this.$store.dispatch('SetMenuName', menuname);
		}
	},
	computed: {
		...mapState(["appweb", "gameId"])
	}
};
</script>
<style>
a {
	text-decoration: none;
}
.header {
	height: 90px;
	width: 100%;
	border-radius: 0px 0px 2px 2px;
	background-position: center center;
	background-repeat: no-repeat;
}

.menu-wrap ul {
	margin: 0px;
	padding: 0px;
	top: 54px;
	border: 0px;
}
.menu {
	margin: 0 auto;
}
.menu li {
	padding: 15px 20px 15px 15px;
	cursor: pointer;
}

.menu_main_li {
	position: relative;
	left: -18px;
}

.submenu {
	border-radius: 0px;
}
.submenu li {
	padding: 13px 13px;
	border: 0px;
	border-top: 1px solid;
}
.submenu li:first-child {
	border-top: 0px !important;
}
.menu a {
	text-decoration: none;
	color: #ffffff;
}
.menu a :active {
	text-decoration: none;
	color: #ffffff;
}
.menu a :focus {
	text-decoration: none;
	color: #ffffff;
}
.menu a :visited {
	text-decoration: none;
	color: #ffffff;
}
.menu a :link {
	text-decoration: none;
	color: #ffffff;
}
.menu a :hover {
	text-decoration: none;
	color: #ffffff;
}
.nav > li:hover .dropdown-menu {
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/xd-header.vue